// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2lREo","title":"Images45_title__jBxt7","images":"Images45_images__19ot-"};